import { render, staticRenderFns } from "./MyInput.vue?vue&type=template&id=98177014&"
import script from "./MyInput.vue?vue&type=script&lang=js&"
export * from "./MyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports